import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PasswordInput,
  Button,
  Paper,
  Title,
  Container,
  Stack,
  Alert,
  Text,
} from '@mantine/core';
import { authApi } from '@/services/auth.api';
import { useAuth } from '@/features/auth/useAuth';

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (next.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (next !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await authApi.changePassword(current, next);
      checkAuth();
      navigate('/dashboard');
    } catch (err: any) {
      const msg = err?.response?.data?.message;
      setError(Array.isArray(msg) ? msg.join(' ') : msg || 'Could not change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Title ta="center" mb="md">
        Set a new password
      </Title>
      <Text ta="center" c="dimmed" size="sm" mb="xl">
        You&apos;re using a temporary password. Choose a new one to continue.
      </Text>
      <Paper withBorder shadow="md" p={30} radius="md">
        <form onSubmit={handleSubmit}>
          <Stack>
            {error && (
              <Alert color="red" title="Error">
                {error}
              </Alert>
            )}
            <PasswordInput
              label="Current (temporary) password"
              required
              value={current}
              onChange={(e) => setCurrent(e.currentTarget.value)}
            />
            <PasswordInput
              label="New password"
              required
              value={next}
              onChange={(e) => setNext(e.currentTarget.value)}
            />
            <PasswordInput
              label="Confirm new password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.currentTarget.value)}
            />
            <Button type="submit" fullWidth loading={loading}>
              Update password
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
